/**
 * Dot Menu
 * Menu used in drilldowns to provide more options such as delete
 * and edit
 */
import React, { useEffect, useState, useRef } from 'react';

import Icon from '@components/Icon/Icon';

import {
  DotsComponent,
  IndividualSetting,
  SettingContainer,
} from './DotMenu.style';

export type DotMenuAction = {
  enabled?: boolean;
  handleClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  title: string;
};

const DotMenu: React.FC<{ actions: DotMenuAction[] }> = ({ actions = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dotRef = useRef<HTMLInputElement>(null);

  function handleClose(event: MouseEvent) {
    if (dotRef.current && !dotRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClose, false);
    return () => {
      document.removeEventListener('mousedown', handleClose, false);
    };
  });

  return (
    <DotsComponent onClick={() => setIsOpen(true)} open={isOpen}>
      <Icon
        clickable
        color="common.white"
        name="ellipsis-vertical"
        type="fas"
      />
      <SettingContainer open={isOpen} ref={dotRef}>
        {actions.map(({ enabled = true, handleClick, title }) => (
          <IndividualSetting
            data-testid="dotmenu-individual-setting"
            enabled={enabled}
            key={title}
            onClick={(event) => enabled && handleClick(event)}
          >
            {title}
          </IndividualSetting>
        ))}
      </SettingContainer>
    </DotsComponent>
  );
};

export default DotMenu;
